import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import type { RootState } from '@/store/store';
import AuthPreloader from './AuthPreloader';
// import { userCreate } from '../api/resources/users';
import { useNavigate } from 'react-router-dom';

interface AdminAuthGuardProps {
  children: React.ReactNode;
}

const AdminAuthGuard: React.FC<AdminAuthGuardProps> = ({ children }) => {
  const { getIdTokenClaims, isAuthenticated } = useAuth0();
  const userInfo = useSelector((state: RootState) => state.user);
  const [isSuperAdmin, setIsSuperAdmin] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkSuperAdminStatus = async () => {
      if (!isAuthenticated) {
        setIsSuperAdmin(false);
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        // console.log('AdminAuthGuard:', userInfo);
        setIsSuperAdmin(userInfo?.data?.superadmin as boolean);
        
      } catch (err) {
        console.error('AuthAdminGuard: Error checking superadmin status:', err);
        setIsSuperAdmin(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkSuperAdminStatus();
  }, [isAuthenticated, userInfo]);

  // Show loading while checking admin status
  if (isLoading) {
    return <AuthPreloader />;
  }

  // Redirect to devices if not a superadmin
  if (!isSuperAdmin) {
    navigate('/devices');
    return null;
  }

  // User is a superadmin, render the protected content
  return <>{children}</>;
};

export default AdminAuthGuard